import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const SendArmRateChangeNotificationEvent = BaseLoanEvent.extend({
  type: z.literal('sendArmRateChangeNotification'),
});
export type SendArmRateChangeNotificationEvent = z.infer<typeof SendArmRateChangeNotificationEvent>;
